import { call, put, takeLatest, delay } from 'redux-saga/effects';

import api from '~/services/api';
import { getSDK, getSDKSuccess, getSDKFailure } from '.';

export default function* rootSaga() {
	yield takeLatest(getSDK, getSDKSaga);
}

function* getSDKSaga({ payload }) {
	try {
		yield delay(500);
		const { data } = yield call(api.get, `/companies/slug/${payload}/sdk`);
		yield put(getSDKSuccess(data.data));
	} catch (error) {
		yield put(getSDKFailure(error.response.data.error));
	}
}
